module.exports = __webpack_public_path__ + "static/img/preview-03.5db1dfe6.webp";